/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0569/0340/1562/files/20251119-p1.png",
    "https://cdn.shopify.com/s/files/1/0569/0340/1562/files/20251119-p2.png",
    "https://cdn.shopify.com/s/files/1/0569/0340/1562/files/20251119-p3.png",

    "https://cdn.shopify.com/s/files/1/0569/0340/1562/files/20251119-p1-2.png",
    "https://cdn.shopify.com/s/files/1/0569/0340/1562/files/20251119-p2-2.png",
    "https://cdn.shopify.com/s/files/1/0569/0340/1562/files/20251119-p3-2.png",

    "https://cdn.shopify.com/s/files/1/0569/0340/1562/files/20251119-b1.png",
    "https://cdn.shopify.com/s/files/1/0569/0340/1562/files/20251119-b2.png",
    "https://cdn.shopify.com/s/files/1/0569/0340/1562/files/20251119-b3.png",
  ];

  // 置顶轮播
  new Swiper(".sp-swiper-fade-top", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  // 按钮轮播
  new Swiper(".sp-btn-style1 .swiper", {
    spaceBetween: 10,

    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      reverseDirection: true,
    },
    loop: true,
  });

  new Swiper(".sp-swiper0", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 20,
    loop: true,
  });

  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    loop: true,
    // slidesPerGroup: 2,
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 0,
    centerSlidesBounds: true,
    centeredSlides: true,
    loop: true,
    effect: "coverflow",
    slidesPerView: 2, // 设置slider容器能够同时显示的slides数量(carousel模式)
    centeredSlides: true,
    coverflowEffect: {
      rotate: 0,
      stretch: -200, // 每个slide之间的拉伸值，越大slide靠得越紧。
      depth: 550, //slide的位置深度。值越大z轴距离越远，看起来越小。
      modifier: 1,
      slideShadows: false,
    },
  });
  new Swiper(".sp-swiper1-mobile", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: ".sp-pagination1",
      clickable: true,
    },
  });

  let spswiper2, spswiper3;
  spswiper2 = new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    on: {
      // slide切换时触发
      slideChange: function (e) {
        $(".sp_pc .sp-swiper-check .sp-btn")
          .eq(e.realIndex)
          .addClass("sp-active")
          .siblings()
          .removeClass("sp-active");
        spswiper3.slideToLoop(e.realIndex);
      },
    },
  });
  spswiper3 = new Swiper(".sp-swiper3", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    // speed: 0,
    spaceBetween: 10,
    on: {
      // slide切换时触发
      slideChange: function (e) {
        $(".sp_pc .sp-swiper-check .sp-btn")
          .eq(e.realIndex)
          .addClass("sp-active")
          .siblings()
          .removeClass("sp-active");
        spswiper2.slideToLoop(e.realIndex);
      },
    },
  });

  // 点击选项时切换swiper
  $(".sp_pc .sp-swiper-check .sp-btn").click(function () {
    $(this).siblings().removeClass("sp-active");
    $(this).addClass("sp-active");

    let colorOptions = $(".sp_pc .sp-swiper-check .sp-btn.sp-active").index();
    spswiper2.slideToLoop(colorOptions);
    spswiper3.slideToLoop(colorOptions);
  });

  // 移动

  let spswiper22, spswiper33;
  spswiper22 = new Swiper(".sp-swiper2-mobile", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    on: {
      // slide切换时触发
      slideChange: function (e) {
        $(".sp_mobile .sp-swiper-check .sp-btn")
          .eq(e.realIndex)
          .addClass("sp-active")
          .siblings()
          .removeClass("sp-active");
        spswiper33.slideToLoop(e.realIndex);
      },
    },
  });
  spswiper33 = new Swiper(".sp-swiper3-mobile", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    // speed: 0,
    spaceBetween: 10,
    on: {
      // slide切换时触发
      slideChange: function (e) {
        $(".sp_mobile .sp-swiper-check .sp-btn")
          .eq(e.realIndex)
          .addClass("sp-active")
          .siblings()
          .removeClass("sp-active");
        spswiper22.slideToLoop(e.realIndex);
      },
    },
  });

  // 点击选项时切换swiper
  $(".sp_mobile .sp-swiper-check .sp-btn").click(function () {
    $(this).siblings().removeClass("sp-active");
    $(this).addClass("sp-active");

    let colorOptions = $(
      ".sp_mobile .sp-swiper-check .sp-btn.sp-active"
    ).index();
    spswiper22.slideToLoop(colorOptions);
    spswiper33.slideToLoop(colorOptions);
  });

  // pc-产品点击放大
  $(".sp_product_box").click(function () {
    $(this).addClass("sp-active").siblings().removeClass("sp-active");
  });

  jQuery(".sp-scroll2").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $(".sp-nav").height()
            : targetElement.offsetTop;

        let sptop = document.body.clientWidth <= 1080 ? 60 : 25;

        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            sptop * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();
  let prods = window.product
  let sp_prices = [
    [
      {
        price1: prods[0].price / 100,
        price2: prods[0].compare_at_price / 100,
      },
 
    ],
    [
      {
        price1: prods[1].price / 100,
        price2: prods[1].compare_at_price / 100,
      },

    ]
  ];

  let sp_price1, sp_price2;
  let amountIndex = $(".sp_product_box1 .sp-opt.sp-active").index();
  let input = $("#calcNumber")[0];

//   let sp_prices_cur = sp_prices[0][amountIndex];

//   sp_price1 = sp_prices_cur.price1;
//   sp_price2 = sp_prices_cur.price2;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);

    return result.toFixed(2);
  }
  function getCur (id){
    return window.product.find(i=>i.id == id)
  }
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    const id = $(this).parents(".sp_product_box").find(".sp-btn-style").attr("data-id");
    const sp_price1 = getCur(id).price/100;
    const sp_price2 = getCur(id).compare_at_price/100;
    $(this).closest('.sp_product_box').find("#sp_price1").html("£" + calcTotal(sp_price1, input.value));
    $(this).closest('.sp_product_box').find("#sp_price2").html("£" + calcTotal(sp_price2, input.value));
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    const id = $(this).parents(".sp_product_box").find(".sp-btn-style").attr("data-id");
    const sp_price1 = getCur(id).price/100;
    const sp_price2 = getCur(id).compare_at_price/100;
    $(this).closest('.sp_product_box').find("#sp_price1").html("£" + calcTotal(sp_price1, input.value));
    $(this).closest('.sp_product_box').find("#sp_price2").html("£" + calcTotal(sp_price2, input.value));
  });
  let proNumList = [1, 2, 3];

  //  产品切换
  $(".sp_product_box .sp-opt").click(function () {
    $(this).siblings().removeClass("sp-active");
    $(this).addClass("sp-active");
    let _index = $(this).index();
    let num = $(this).parents(".sp_product_box").find('.addGroup').find('input').val()
    num == undefined ? num = 1 : ''

    let spParent = $(this).parents(".sp_product_box");

    spParent.find(".sp-p-img").eq([_index]).show().siblings(".sp-p-img").hide();
    let spPrice1, spPrice2;

    spPrice1 = sp_prices[spParent.index()][_index].price1.toFixed(2);
    spPrice2 = sp_prices[spParent.index()][_index].price2.toFixed(2);
    console.log(spPrice1,spPrice2)

    if (spParent.find(".sp-price3").length > 0) {
      spParent.find(".sp-price1").html("$" + spPrice1);
      spParent.find(".sp-price2").html("$" + spPrice2);
      let spPrice3 = spPrice1 / proNumList[spParent.index()];

      spParent
        .find(".sp-price3 .sp-span")
        .html("$" + spPrice3.toFixed(2) + "/");
    } else {
      $(this).closest('.sp_product_box').find("#sp_price1").html("$" + calcTotal(spPrice1, num));
      $(this).closest('.sp_product_box').find("#sp_price2").html("$" + calcTotal(spPrice2, num));
    }
  });

  $('.sp-btn-style').on('click',function(){
    //  let id = $(this).siblings('.sp-opt-group').find('.sp-active').data('id');
    let id = $(this).attr("data-id")
     let num = $(this).siblings('.addGroup').find('input').val()
     num == undefined ? num = 1 : ''
     window.location.href = '/cart/' + id + ':' + num
   })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $(".sp-menu-mask").hide();
    // }
  });

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $(".sp_header").height() * $("div#root").css("zoom")
  ) {
    $(".sp_header-wrap").addClass("sp-fixed");
  } else {
    $(".sp_header-wrap").removeClass("sp-fixed");
  }

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $(".sp_header").height() * $("div#root").css("zoom")
    ) {
      $(".sp_header-wrap").addClass("sp-fixed");
    } else {
      $(".sp_header-wrap").removeClass("sp-fixed");
    }
  });

  $(document).on("click", ".sp_buy_now", function () {
    console.log("xxx111");
  });

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
